type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

export const INGREDIENT_TYPES_MAP: Record<INGREDIENT_TYPES, string> = {
  meter: 'Metro',
  unit: 'Unidade',
  volume: 'Volume',
  weight: 'Peso'
}

type MeasureOption = { name: string; value: string }

export const INGREDIENT_PRICE_MEASURE_OPTIONS: Record<
  INGREDIENT_TYPES,
  MeasureOption[]
> = {
  weight: [
    { name: 'Kilo', value: 'Kilo' },
    { name: 'Grama', value: 'Grama' },
    { name: 'Miligrama', value: 'Miligrama' }
  ],
  volume: [
    { name: 'Litro', value: 'Litro' },
    { name: 'Mililitro', value: 'Mililitro' }
  ],
  unit: [{ name: 'Unidade', value: 'Unidade' }],
  meter: [{ name: 'Metro', value: 'Metro' }]
}

const nameEntity = 'Ingredient'
const nameSource = 'commercial/ingredients'
const namePageTitle = 'Ingredientes'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Tipos de item',
  to: '/commercial/ingredients',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/commercial/ingredients/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/commercial/ingredients/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/commercial/ingredients/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
